import React from "react";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";

const CustomBreadcrumb = ({ options }) => {
  const items = options.map((item) => {
    return {
      title: item.link ? <Link to={item.link}>{item.title}</Link> : item.title,
    };
  });
  return <Breadcrumb items={items} />;
};

export default CustomBreadcrumb;
